import { EmrClinicalOrders, EmrClinicalNotes, EmrConsultation, EmrClinicalForm, EmrBodyInOutMaterials } from './medical-recored.interfaces';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { getDateObj, getNgBsObj } from '../shared';
import { EmrTreatmentRecord } from '../medical-sheets/custom-sheet/custom-sheet.interface';

export class ClinicalOrdersHelper {
  constructor(
  ) {
  }
  saveData(clinicalOrders: EmrClinicalOrders[], patient: any): EmrClinicalForm[] {
    let formList = <Array<EmrClinicalForm>>[];
    let cc = 0;

    clinicalOrders.forEach(item => {
      cc = cc + 1;
      item.orderType = 1;
      item.serial = item.serial > 0 ? item.serial : cc * -1;
      item.visitSerial = patient.visitSerial;
    });
    clinicalOrders.forEach(co => {
      let coCopy = Object.assign({}, co);
      let form = <EmrClinicalForm>{};
      form.serial = coCopy.serial;
      delete coCopy.serial;
      form.visitSerial = coCopy.visitSerial;
      delete coCopy.visitSerial;
      form.formKey = 1;
      form.jsonObject = JSON.stringify(coCopy);
      formList.push(form);
    });
    return formList;
  }
  getSaved(SheetParms: any) {
    return '';
  }
  newObject(storeList: EmrClinicalOrders[]) {
    let order = <EmrClinicalOrders>{ serial: (storeList.length + 1) * -1, dataStatus: 1 };
    storeList.unshift(order);

   // storeList.push(order);
  }
  newTreatmentRecordObject(list: EmrTreatmentRecord[]) {
    let order = <EmrTreatmentRecord>{ serial: (list.length + 1) * -1, dataStatus: 1 };
    list.push(order);
  }
}

export class EmrClinicalNotesHelper {
  constructor(
  ) {
  }
  saveData(notes: EmrClinicalNotes[], patient: any): EmrClinicalForm[] {

    let cc = 0;
    notes.forEach(item => {
      cc = cc + 1;
      item.serial = cc * -1;
      item.visitSerial = patient.visitSerial;
    });
    return EmrClinicalFormHelper.makeFormList(notes, 2);
  }
  getSaved(SheetParms: any) {
    return '';
  }
  newObject(storeList: EmrClinicalNotes[], formKey: number) {
    let note = <EmrClinicalNotes>{ serial: (storeList.length + 1) * -1, notesType: 1, dataStatus: 1 };
    storeList.push(note);
  }

}

export class EmrConsultationHelper {
  static FullScreenView: any;
  constructor(
  ) {
  }
  saveData(consultaionList: EmrConsultation[], patient: any): EmrClinicalForm[] {
    let cc = 0;
    consultaionList.forEach(item => {
      cc = cc + 1;
      item.serial = cc * -1;
      item.visitSerial = patient.visitSerial;
    });
    return EmrClinicalFormHelper.makeFormList(consultaionList, 3);
  }
  getSaved(SheetParms: any) {
    return '';
  }
  newObject(storeList: EmrConsultation[], formKey: number) {
    let order = <EmrConsultation>{ serial: (storeList.length + 1) * -1, status: 1, dataStatus: 1 };
    storeList.unshift(order);
  }

}
export class EmrClinicalFormHelper {

  static makeFormList(list: any[], formKey: number): EmrClinicalForm[] {

    let formList = <Array<EmrClinicalForm>>[];
    list.forEach(co => {
      let coCopy = Object.assign({}, co);
      let form = <EmrClinicalForm>{};
      form.serial = coCopy.serial;
      delete coCopy.serial;
      form.visitSerial = coCopy.visitSerial;
      delete coCopy.visitSerial;
      form.formKey = formKey;
      form.jsonObject = JSON.stringify(coCopy);
      formList.push(form);
    });

    return formList;
  }

}
export class BodyInOutMaterialsHelper {
  constructor(
  ) {
  }
  saveData(bodyInOutMaterials: EmrBodyInOutMaterials[], patient: any): EmrClinicalForm[] {
    let formList = <Array<EmrClinicalForm>>[];
    let cc = 0;

    bodyInOutMaterials.forEach(item => {
      cc = cc + 1;
      item.inOutFlag = 1;
      item.serial = item.serial > 0 ? item.serial : cc * -1;
      item.visitSerial = patient.visitSerial;
    });
    bodyInOutMaterials.forEach(co => {
      let coCopy = Object.assign({}, co);
      let form = <EmrClinicalForm>{};
      form.formKey = 4;
      form.jsonObject = JSON.stringify(coCopy);
      formList.push(form);
    });
    return formList;
  }
  getSaved(SheetParms: any) {
    return '';
  }

  newObject(storeList: EmrBodyInOutMaterials[], subEntry: EmrBodyInOutMaterials) {
    let entry = <EmrBodyInOutMaterials>{ serial: (storeList.length + 1) * -1, dataStatus: 1 };
    entry = Object.assign({}, entry, subEntry);
    storeList.push(entry);
  }

}
//


export class SheetsHelper {

  constructor() { }

  saveData(formValue: any, formKey: number, myInputs: any): EmrClinicalForm[] {
    let formList = <Array<EmrClinicalForm>>[];

    if (formValue != null)
      myInputs.forEach(xx => {
        if (xx.inputType == 'date') {
          formValue[xx.controlName] = getDateObj(formValue[xx.controlName + 'NGB']);
        }
      });

    let coCopy = Object.assign({}, formValue);
    let form = <EmrClinicalForm>{};
    form.serial = coCopy.serial ? coCopy.serial : (-1);
    delete coCopy.serial;
    form.visitSerial = coCopy.visitSerial;
    delete coCopy.visitSerial;
    form.formKey = formKey;
    coCopy.dataStatus = form.serial > 0 ? 2 : 1;
    form.jsonObject = JSON.stringify(coCopy);
    formList.push(form);
    return formList;
  }
  assignDates(formValue: any, myInputs: any) {
    if (formValue != null)
      myInputs.forEach(xx => {
        if (xx.inputType == 'date') {
          formValue[xx.controlName + 'NGB'] = getNgBsObj(formValue[xx.controlName]);
        }
      });
  }
  createForm(searchForm: UntypedFormGroup, fb: UntypedFormBuilder, jsonData: any): { searchForm: UntypedFormGroup, inputs: any[] } {
    let inputs: any[] = [];

    if (searchForm) {
      searchForm.reset();
    } else {
      searchForm = fb.group({ fastSearchData: '' });
    }
    for (var property in jsonData) {
      let x = jsonData[property];
      x.controlName = property;
      inputs.push(jsonData[property]);
      if (x.inputType == 'date') {
        searchForm.addControl(property + 'NGB', new UntypedFormControl());
      } else
        searchForm.addControl(property, new UntypedFormControl());
    };
    return { searchForm, inputs };
  }
}


export enum SheetFormType {
  PostoperativeEvent = 6,
  Readission = 7,
  EmrStsAnesth = 5,
  dischargeMortality = 8,
  Postoperative = 9,
  Operative = 10,
  valveSurgery = 11
}